// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-2FOyePsh"};